'use client';

import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

interface AOSProviderProps {
  children: React.ReactNode;
}

/**
 * Client Component that handles AOS (Animate On Scroll) initialization.
 * Separated from MainLayout to allow MainLayout to remain a Server Component.
 */
export default function AOSProvider({ children }: AOSProviderProps) {
  useEffect(() => {
    AOS.init({
      once: true,
      offset: 50,
      duration: 800,
    });
  }, []);

  return <>{children}</>;
}
